import qs from 'query-string';
import { createSelector } from 'reselect';

export const getQueryString = createSelector(
  ({ querystring }) => qs.stringify(querystring),
  (str) => str,
);

export const getServerConfig = createSelector(
  ({ serverConfig }) => serverConfig,
  (config) => config,
);
